import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Redirect, useHistory } from 'react-router-dom'

import http from '../../../../shared/http'
import { TApi, TRoutes } from '../../../../shared/const'
import { formatMinutes, mediaUrl } from '../../../../shared/courses'

import PreviewBanner from './PreviewBanner'

import styles from './style.module.scss'

/**
 * Alle Kurse als Kacheln. Gibt es für eine Schüler:in genau einen, geht es
 * gleich auf dessen Seite — eine Auswahl aus einem ist keine.
 */
export default function CourseList({ embedded, title }) {
	const { t } = useTranslation()
	const history = useHistory()
	const [stand, setStand] = useState(null)

	useEffect(() => {
		http.get(TApi.COURSES, { disableToast: true })
			.then(({ data }) => setStand(data))
			.catch(() => setStand({ enabled: false, courses: [] }))
	}, [])

	if (!stand) {
		return embedded ? null : (
			<div className={styles.root}>
				<p className={styles.loading}>{t('Loading…')}</p>
			</div>
		)
	}

	const kurse = stand.courses || []

	if (!embedded && stand.mode !== 'PREVIEW' && kurse.length === 1) return <Redirect to={TRoutes.COURSE(kurse[0].id)} />

	const inhalt = (
		<>
			<h1 className={styles.pageTitle}>{title || t('Courses')}</h1>
			{kurse.length === 0 && (
				<p className={styles.empty}>
					{stand.enabled ? t('There are no courses for you at the moment.') : t('Courses are switched off.')}
				</p>
			)}
			<div className={styles.grid}>
				{kurse.map(kurs => (
					<button
						key={kurs.id}
						type="button"
						className={styles.card}
						onClick={() => history.push(TRoutes.COURSE(kurs.id))}
					>
						<div
							className={styles.thumb}
							style={kurs.coverUrl ? { backgroundImage: `url("${mediaUrl(kurs.coverUrl)}")` } : undefined}
						>
							{kurs.progress?.completed && (
								<span className={styles.check} aria-label={t('Completed')}>
									✓
								</span>
							)}
						</div>
						<div className={styles.cardBar} aria-hidden="true">
							<span style={{ width: `${kurs.progress?.percent || 0}%` }} />
						</div>
						<div className={styles.cardBody}>
							<p className={styles.cardTitle}>{kurs.title}</p>
							<span className={styles.cardText}>
								{t('{{n}} modules', { n: kurs.moduleCount || 0 })} ·{' '}
								{t('{{n}} lessons', { n: kurs.lessonCount || 0 })}
								{kurs.durationSec ? ` · ${formatMinutes(kurs.durationSec, t)}` : ''}
							</span>
						</div>
					</button>
				))}
			</div>
		</>
	)

	if (embedded) return inhalt

	return (
		<div className={styles.root}>
			{stand.mode === 'PREVIEW' && <PreviewBanner />}
			{inhalt}
		</div>
	)
}

CourseList.propTypes = {
	// Eingebettet (Lehrkraft-Seite): ohne eigenen Seitenrahmen und ohne Weiterleitung.
	embedded: PropTypes.bool,
	title: PropTypes.string
}

CourseList.defaultProps = {
	embedded: false,
	title: ''
}
